import { initializeApp } from "firebase/app";
import { getAuth, updateProfile, signInWithCustomToken  } from "firebase/auth";

export interface User {
    firstName: string,
    lastName: string
}

class FirebaseAuthBackend {

    firebaseApp = null;
    auth = null;

    constructor(firebaseConfig) {
        if (firebaseConfig) {
            // Initialize Firebase
            this.firebaseApp = initializeApp(firebaseConfig);
            this.auth = getAuth(this.firebaseApp);
            this.auth.onAuthStateChanged((user) => {
                if (user) {
                    localStorage.setItem('authUser', JSON.stringify(user));
                } else {
                    localStorage.removeItem('authUser');
                }
            });
            this.auth.onIdTokenChanged(function(user) {
                if (user) {
                    localStorage.setItem('authUser', JSON.stringify(user));
                }
            });
        }
    }
    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            this.auth.signOut().then(() => {
                localStorage.removeItem('authUser');
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    setLoggeedInUser = (user) => {
        localStorage.setItem('authUser', JSON.stringify(user));
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        if (!localStorage.getItem('authUser')) {
            return null;
        }
        return JSON.parse(localStorage.getItem('authUser'));
    }

    signInWithToken = (token) => {
        return signInWithCustomToken(this.auth, token)
        .then((userCredential) => {
            const user = userCredential.user;
            this.setLoggeedInUser(user);
            return user;
        })
    }

    /**
     * update profile 
     */
    updateProfile = (data:any) => {
        return new Promise((resolve, reject) => {
            updateProfile(this.auth.currentUser, data).then(() => {
                this.setLoggeedInUser(this.auth.currentUser);
                resolve(true)
            }).catch((error) => {
                reject(false)
            });
        })
    }

    /**
     * Handle the error
     * @param {*} error
     */
    _handleError(error) {
        // tslint:disable-next-line: prefer-const
        const errorMessage = error.message;
        return errorMessage;
    }
}

// tslint:disable-next-line: variable-name
let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config
 */
const initFirebaseBackend = (config) => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend(config);
    }
    return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
    return _fireBaseBackend;
};

export { initFirebaseBackend, getFirebaseBackend  };
